import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private api = inject(ApiService);

  get(isAll: 'all' | '' = '') {
    const path = isAll === 'all' ? '/notification/all' : '/notification/use_to_select';
    return this.api.get(path);
  }
  upsert(json: any) { return this.api.post('/notification', json); }
  async changeStatus(json: any): Promise<any> {
    const response = await firstValueFrom(this.api.postRaw('/notification/status', json));
    if (response?.success !== true) throw new Error(response?.error || '申請ステータスを更新できませんでした。');
    return response.result;
  }
  remove(id: number) { return this.api.get(`/notification/remove/${id}`); }
  unprocessedExists() { return this.api.get('/notification/exists'); }
  createInsuranceForUpdateMember(json: any) { return this.api.post('/notification/insurance', json); }
  removeInsuranceForUpdateMember(id: number) { return this.api.get(`/member/${id}/insurance/remove`); }
  createCsvAll() { return this.api.get('/studio/all/notification/csv/'); }
}
